import React from 'react';
import Cell from './Cell';

const Board = ({ board, revealedCells, flaggedCells, onCellClick, onCellRightClick, gameOver }) => {
  return (
    <div className="board">
      {board.map((row, rowIndex) => (
        <div key={rowIndex} className="row">
          {row.map((cell, colIndex) => (
            <Cell
              key={`${rowIndex}-${colIndex}`}
              value={cell}
              isRevealed={revealedCells[rowIndex]?.[colIndex] || false}
              isFlagged={flaggedCells[rowIndex]?.[colIndex] || false}
              onClick={() => onCellClick(rowIndex, colIndex)}
              onRightClick={(e) => onCellRightClick(e, rowIndex, colIndex)}
              gameOver={gameOver}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Board;
